import { render, staticRenderFns } from "./ClusterPermissionsEditor.vue?vue&type=template&id=c67a8f92&scoped=true&"
import script from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js&"
export * from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClusterPermissionsEditor.vue?vue&type=style&index=0&id=c67a8f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67a8f92",
  null
  
)

export default component.exports